import React from 'react';

import {
  ChallengeDetailsModal,
  RemoveIncentiveModal,
  ReplaceIncentiveModalProvider,
} from '../../modals';

export const LoyaltyModalsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ReplaceIncentiveModalProvider>
      {children}
      <RemoveIncentiveModal />
      <ChallengeDetailsModal />
    </ReplaceIncentiveModalProvider>
  );
};
